import { render, staticRenderFns } from "./UblOverview.vue?vue&type=template&id=4253bf3d&scoped=true"
import script from "./UblOverview.vue?vue&type=script&lang=ts"
export * from "./UblOverview.vue?vue&type=script&lang=ts"
import style0 from "./UblOverview.vue?vue&type=style&index=0&id=4253bf3d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253bf3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4253bf3d')) {
      api.createRecord('4253bf3d', component.options)
    } else {
      api.reload('4253bf3d', component.options)
    }
    module.hot.accept("./UblOverview.vue?vue&type=template&id=4253bf3d&scoped=true", function () {
      api.rerender('4253bf3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/UblOverview.vue"
export default component.exports